import { createContext } from "react";

export const errorAlertContext = createContext<
  ((error: unknown) => void) | undefined
>(undefined);
